import { EntityType, RelationshipType, ResourceType } from "@resource/models";

export interface FilterOptions {
  serialNumbers?: string[];
  resourceType?: ResourceType;
  productFamilyName?: string;
  entityId?: string; // GUID of target Organization
  entityType?: EntityType; // MAYBE remove, if value EntityType.Organization is ALWAYS
  relationshipType?: RelationshipType;
}

export enum SortByForResources {
  SerialNumber = "SerialNumber",
  ResourceType = "ResourceType",
  ProductFamilyName = "ProductFamilyName",
  RelationshipType = "RelationshipType"
}
